import { Toast } from "vant";
import kioskUtil from "./kioskUtil";

// *
const isKiosk = () => {
  let f = location.search.includes("kiosk=1");
  if (f) return true;
  return kioskUtil.kiosk.get();
};

const $toast = {
  loading(options = {}) {
    if (isKiosk()) {
      kioskUtil.loading.show(options.message);
    } else {
      Toast.loading(options);
    }
  },
  clear() {
    if (isKiosk()) {
      kioskUtil.loading.hide();
    } else {
      Toast.clear();
    }
  },
};

export default {
  install(app) {
    app.prototype.$_toast = $toast;
  },
};
